// Store User
const state = {
    user: {
        'full_name': '',
        'email': '',
        'avatar': '',
        'type': '',
        'options': '',
        'parent': null,
        'lang': null
    }
};

const mutations = {
    'SET_FULLNAME' (state, fullname) {
        state.user.fullname = fullname;
    },
    'SET_EMAIL' (state, email) {
        state.user.email = email;
    },
    'SET_AVATAR' (state, avatar) {
        if(avatar){
            state.user.avatar = avatar;
        }else{
            state.user.avatar = "https://api.agendaenlinea.cl/image/default_avatar.png";
        }
    },
    'SET_USER' (state, user) {
        state.user = user;
    },
    'SET_TYPE' (state, type) {
        state.user.type = type;
    },
    'SET_OPTIONS' (state, options) {
        state.user.options = options;
    },
    'SET_PARENT' (state, parent) {
        state.user.parent = parent;
    },
    'CLEAR_USER' (state){
        state.user  = {};
    },
    'SET_LANG_USER' (state, lang){
        state.user.lang = lang;
    }
};

const actions = {
    setFullname: ({commit}, fullname) => {
        commit('SET_FULLNAME', fullname);
    },
    setEmail: ({commit}, email) => {
        commit('SET_EMAIL', email);
    },
    setAvatar: ({commit}, avatar) => {
        commit('SET_AVATAR', avatar);
    },
    setUser: ({commit}, user) => {
        commit('SET_USER', user);
    },
    setType: ({commit}, type) => {
        commit('SET_TYPE', type);
    },
    setParent: ({commit}, parent) => {
        commit('SET_PARENT', parent);
    },
    clearUser: ({commit}) => {
        commit('CLEAR_USER');
    },
    setLangUser: ({commit}, lang) => {
        commit('SET_LANG_USER', lang);
    },
};

const getters = {
    user: state => {
        return state.user;
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js